import { createAction } from 'Lib/reduxUtils';

import {
  BOOST_END,
  SEND_BOOST_TUTORIAL_VIEWED,
  SET_BOOST_SOURCE_VERSION,
  START_BOOST,
  START_BOOST_FAILURE,
  START_BOOST_SUCCESS,
  START_BOOST_TIMER,
  START_POLL_PRIMETIME_BOOST,
  STOP_POLL_PRIMETIME_BOOST,
} from './constants';

type Payload = {
  amount: number;
};

export const startBoost = createAction(START_BOOST, (from?: number, boostPayload?: Payload) => ({
  from,
  boostPayload,
}));
export const startBoostSuccess = createAction(START_BOOST_SUCCESS, (boostData: any) => boostData);
export const startBoostFailure = createAction(START_BOOST_FAILURE, (error: any) => error);

export const sendBoostTutorialViewed = createAction(SEND_BOOST_TUTORIAL_VIEWED);
export const startBoostTimer = createAction(
  START_BOOST_TIMER,
  (payload: { expiration: number }) => payload
);

export const boostEnd = createAction(BOOST_END);
export const setBoostSourceVersion = createAction(
  SET_BOOST_SOURCE_VERSION,
  (version: number) => version
);

export const startPollPrimetimeBoost = createAction(START_POLL_PRIMETIME_BOOST);
export const stopPollPrimetimeBoost = createAction(STOP_POLL_PRIMETIME_BOOST);
